/**
 * @generated SignedSource<<b1f1f7fabd7df2f87194260746c73144>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type InstagramLinkStatus = "FACEBOOK_LOGIN_EXPIRED" | "LINKED" | "UNLINKED";
import { FragmentRefs } from "relay-runtime";
export type MyPageSns$data = {
  readonly instagramLinkStatus: InstagramLinkStatus;
  readonly linkingTiktok: boolean | null;
  readonly linkingTwitter: boolean | null;
  readonly profile: {
    readonly tiktokUrl: string | null;
    readonly ytChannel: string | null;
  };
  readonly tiktokOauthEnabled: boolean;
  readonly " $fragmentType": "MyPageSns";
};
export type MyPageSns$key = {
  readonly " $data"?: MyPageSns$data;
  readonly " $fragmentSpreads": FragmentRefs<"MyPageSns">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MyPageSns",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "instagramLinkStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "linkingTwitter",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "linkingTiktok",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tiktokOauthEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "InfluencerInfo",
      "kind": "LinkedField",
      "name": "profile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ytChannel",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "tiktokUrl",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Influencer",
  "abstractKey": null
};

(node as any).hash = "2c5f5f686125b2d894ef8c28537edb4c";

export default node;
